export default __webpack_public_path__ + "static/media/no-redux-vs-redux.212920d6.png";